import React from "react";

const backdropStyles = {
  position: "fixed",
  top: "0",
  left: "0",
  bottom: "0",
  right: "0",
  backgroundColor: "rgba(0,0,0,0.45)",
  zIndex: "50",
};

const backdrop = ({ show, onClose }) => {
  return show && <div style={backdropStyles} onClick={onClose}></div>;
};

export default backdrop;
